import React from 'react';
import { Instagram, Heart } from 'lucide-react';
export function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-charcoal text-white pt-16 pb-8" data-id="element-82">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83">
        <div className="flex flex-col items-center text-center mb-12" data-id="element-84">
          <a href="#inicio" onClick={e => handleNavClick(e, '#inicio')} className="flex items-center gap-2 mb-6" data-id="element-85">
            <div className="flex items-center justify-center w-12 h-12 rounded-full border border-rosegold text-rosegold" data-id="element-86">
              <span className="font-serif font-bold text-xl tracking-wider" data-id="element-87">
                SM
              </span>
            </div>
          </a>
          <h2 className="font-serif text-2xl mb-2" data-id="element-88">Studio by Mery</h2>
          <p className="text-white/60 font-light max-w-sm" data-id="element-89">
            Tu espacio de belleza y bienestar en Punta Carretas.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center py-8 border-t border-white/10 gap-6" data-id="element-90">
          <nav data-id="element-91">
            <ul className="flex flex-wrap justify-center gap-6 text-sm text-white/70" data-id="element-92">
              <li data-id="element-93">
                <a href="#inicio" onClick={e => handleNavClick(e, '#inicio')} className="hover:text-rosegold transition-colors" data-id="element-94">
                  Inicio
                </a>
              </li>
              <li data-id="element-95">
                <a href="#nosotros" onClick={e => handleNavClick(e, '#nosotros')} className="hover:text-rosegold transition-colors" data-id="element-96">
                  Nosotros
                </a>
              </li>
              <li data-id="element-97">
                <a href="#servicios" onClick={e => handleNavClick(e, '#servicios')} className="hover:text-rosegold transition-colors" data-id="element-98">
                  Servicios
                </a>
              </li>
              <li data-id="element-99">
                <a href="#equipo" onClick={e => handleNavClick(e, '#equipo')} className="hover:text-rosegold transition-colors" data-id="element-100">
                  Equipo
                </a>
              </li>
            </ul>
          </nav>

          <div className="flex items-center gap-4" data-id="element-101">
            <a href="https://instagram.com/studiomery_" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-rosegold transition-colors" aria-label="Instagram" data-id="element-102">
              <Instagram size={18} data-id="element-103" />
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-xs text-white/40 pt-4 gap-2" data-id="element-104">
          <p data-id="element-105">© 2025 Studio by Mery — Punta Carretas, Montevideo</p>
          <p className="flex items-center gap-1" data-id="element-106">
            Diseñado con{' '}
            <Heart size={12} className="text-rosegold fill-rosegold" data-id="element-107" /> para vos
          </p>
        </div>
      </div>
    </footer>;
}